export default "__VITE_ASSET__jVymOyfY__"